export default __webpack_public_path__ + "static/media/logo_dark.cd752b23.png";